import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import SettingsSystem from '../svg/settings_system.svg';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const context_styles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  width: "17rem",
  backgroundColor: "rgba(24,28,32, 1)",
  height: "fit-content",
  borderRadius: "10px",
  boxSizing: "border-box",
  padding: '0.5em',
}

export const filter_text = {
  color: "rgba(245, 245, 245, 0.875)",
  fontSize: "0.75rem",
  fontFamily: "Josefin Sans",
}

export const filter_menu_Styles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "rgba(245, 245, 245, 0.875)",
  cursor: "pointer"
}

export const menu_header = {
  fontWeight: "bold",
  fontSize: "0.8rem",
  color: "rgb(61,162,131)",
  cursor: "text"
}

export const list_styles = {
  display: "flex",
  justifyContent: "center",
  overflowY: "scroll",
  maxHeight: "7rem",
  minHeight: "fit-content",
  width: "16.5rem",
}

export const filter_close_styles = {
  padding: 0,
  backgroundColor: "rgba(0, 0, 0, 0.05)",
  height: "fit-content",
  borderRadius: "10px",
}

export const context_header_styles = { 
  display: "flex",
  justifyContent: "space-between", 
  alignItems: "center",
  width: "17rem",
  padding: "0.35rem 0.65rem",
  boxSizing: "border-box",
  boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)",
  borderRadius: "10px",
  backgroundColor: "rgb(41,45,57)",
  fontFamily: "Josefin Sans",
}

export const filter_footer_styles = {
  display: "flex",
  justifyContent: "center",
  backgroundColor: "rgba(0, 0, 0, 0.0525)",
  borderRadius: "10px",
  width: "100%",
}

export const BootstrapTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.arrow}`]: {
	color: theme.palette.common.black,
	},
	[`& .${tooltipClasses.tooltip}`]: {
	backgroundColor: theme.palette.common.black,
	},
}));

export const settings_system = (
  <BootstrapTooltip title="Configure Settings" placement="top">
      <IconButton>
          <img
              src={SettingsSystem}
              style={{ width: "1.7rem", height: "1.7rem", padding: "0px", cursor: "pointer" }} 
          />
      </IconButton>
  </BootstrapTooltip>
)

export const FilterOpen = (
  <BootstrapTooltip title="Close Filters" placement="top">
      <IconButton>
          <KeyboardArrowUpIcon sx={{ color: "rgb(61,162,131)", fontSize: '1.3rem', cursor: 'pointer' }} />
      </IconButton>
  </BootstrapTooltip>
)

export const FilterClose = (
  <BootstrapTooltip title="Open Filters" placement="top">
      <IconButton>
          <KeyboardArrowDownIcon sx={{ color: "rgb(61,162,131)", fontSize: '1.3rem', cursor: 'pointer' }} />
      </IconButton>
  </BootstrapTooltip>
)